module.exports = __webpack_public_path__ + "img/face-kiss.b211a42d.svg";